import { ImagesApp } from './images';

export type ResaleEmptyStateType = 'pending' | 'sold' | 'notFound' | 'ownResale' | 'default';

export const resaleEmptyStateImage = ImagesApp.svg.emptyResale;

export const RESALE_PENDING_WAIT_MINUTES = 10;
